export default "__VITE_ASSET__DS2MEBd2__"